<template>
  <transition name="modal">
    <div v-if="visible" class="modal__overlay">
      <div class="modal__wrapper">
        <div class="modal__header"
          :style="{
          color: theme.primaryColor,
        }"
        >
          <h2 class="modal__header__title">{{ $t('chargepointPairing.supportModalTitle') }}</h2>
          <button class="modal__close" @click="$emit('close')" aria-label="Close">
            <img src="../../assets/icons/customModalClose.svg" alt="Close" width="18" height="18" />
          </button>
        </div>
        <div class="modal__content">
          <div class="mobile-steps__wrapper" v-if="isMobile">
            <div class="steps__container">
              <div class="step">
                <div class="step__indicator-container step__indicator-container-one">
                  <div class="step__number" :style="{ backgroundColor: theme.primaryColor }">1</div>
                  <div class="mobile-step__line-bottom"></div>
                </div>
                <div class="step__content">
                  <div class="step__box">
                    <div class="step__icon" v-html="supportStepIconSvg"></div>
                    <p class="step__label">{{ $t('chargepointPairing.modalLabel1') }}</p>
                  </div>
                  <h3 class="step__title">{{ $t('chargepointPairing.modalStepTitle1') }}</h3>
                  <p class="step__description">
                    {{ $t('chargepointPairing.modalStep1') }}
                  </p>
                </div>
              </div>
              <div class="step">
                <div class="step__indicator-container">
                  <div class="mobile-step__line-top"></div>
                  <div class="step__number" :style="{ backgroundColor: theme.primaryColor }">2</div>
                  <div class="mobile-step__line-bottom"></div>
                </div>
                <div class="step__content">
                  <div class="step__box lookup-step-box__container">
                    <div class="lookup-step-box">
                      <div class="lookup-step-box__label">{{ $t('chargepointPairing.modalLabel2') }}</div>
                      <div class="lookup-step-box__input-placeholder"></div>
                    </div>
                  </div>
                  <h3 class="step__title">{{ $t('chargepointPairing.modalStepTitle2') }}</h3>
                  <p class="step__description">
                    {{ $t('chargepointPairing.modalStep2') }}
                  </p>
                </div>
              </div>
              <div class="step">
                <div class="step__indicator-container">
                  <div class="mobile-step__line-top"></div>
                  <div class="step__number" :style="{ backgroundColor: theme.primaryColor }">3</div>
                </div>
                <div class="step__content">
                  <div class="step__box pairing-step-box_container">
                    <div class="pairing-step-box">
                      <div class="pairing-step-box__label pairing-step-box__label1">{{ $t('chargepointPairing.modalLabel3') }}</div>
                      <div class="pairing-step-box__dot"></div>
                      <div class="pairing-step-box__label pairing-step-box__label2">{{ $t('chargepointPairing.modalLabel4') }}</div>
                      <div class="pairing-step-box__label pairing-step-box__label3">{{ $t('chargepointPairing.modalLabel5') }}</div>
                      <div class="pairing-step-box__line"></div>
                    </div>
                  </div>
                  <h3 class="step__title">{{ $t('chargepointPairing.modalStepTitle3') }}</h3>
                  <p class="step__description">
                    {{ $t('chargepointPairing.modalStep3') }}
                  </p>
                </div>
              </div>
              <div class="modal__footer">
                <p class="footer__text1"> {{ $t('chargepointPairing.ending1') }} </p>
                <div class="footer__divider"></div>
                <div class="footer__text2__container">
                  <span class="footer__text2"> {{ $t('chargepointPairing.ending2') }}&nbsp;</span>
                  <a :href="connectionLink" target="_blank" class="footer__text2">{{ $t('chargepointPairing.supportArticleLink') }}&nbsp;</a>
                  <span class="footer__text2"> {{ $t('chargepointPairing.ending3') }}&nbsp;</span>
                  <a
                    class="footer__text2"
                    v-bind:href="'mailto:' + supportEmail"
                    >{{ supportEmail }}</a
                  >
                  <span class="footer__text2">.</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="steps__container">
              <div class="step">
                <div class="step__box">
                  <div class="step__icon" v-html="supportStepIconSvg"></div>
                  <p class="step__label">{{ $t('chargepointPairing.modalLabel1') }}</p>
                </div>
                <div class="step__line__step-one">
                  <div class="step__number" :style="{ backgroundColor: theme.primaryColor }">1</div>
                  <div class="step__divider step__divider-right"></div>
                </div>
                <h3 class="step__title">{{ $t('chargepointPairing.modalStepTitle1') }}</h3>
                <p class="step__description">{{ $t('chargepointPairing.modalStep1') }}</p>
              </div>
              <div class="step">
                <div class="step__box lookup-step-box__container">
                  <div class="lookup-step-box">
                    <div class="lookup-step-box__label">{{ $t('chargepointPairing.modalLabel2') }}</div>
                    <div class="lookup-step-box__input-placeholder"></div>
                  </div>
                </div>
                <div class="step__line">
                  <div class="step__divider step__divider-left"></div>
                  <div class="step__number" :style="{ backgroundColor: theme.primaryColor }">2</div>
                  <div class="step__divider step__divider-right"></div>
                </div>
                <h3 class="step__title">{{ $t('chargepointPairing.modalStepTitle2') }}</h3>
                <p class="step__description">{{ $t('chargepointPairing.modalStep2') }}</p>
              </div>
              <div class="step">
                <div class="step__box pairing-step-box_container">
                  <div class="pairing-step-box">
                    <div class="pairing-step-box__label pairing-step-box__label1">{{ $t('chargepointPairing.modalLabel3') }}</div>
                    <div class="pairing-step-box__dot"></div>
                    <div class="pairing-step-box__label pairing-step-box__label2">{{ $t('chargepointPairing.modalLabel4') }}</div>
                    <div class="pairing-step-box__label pairing-step-box__label3">{{ $t('chargepointPairing.modalLabel5') }}</div>
                    <div class="pairing-step-box__line"></div>
                  </div>
                </div>
                <div class="step__line__step-three">
                  <div class="step__divider step__divider-left"></div>
                  <div class="step__number" :style="{ backgroundColor: theme.primaryColor }">3</div>
                </div>
                <h3 class="step__title">{{ $t('chargepointPairing.modalStepTitle3') }}</h3>
                <p class="step__description">{{ $t('chargepointPairing.modalStep3') }}</p>
              </div>
            </div>
            <div class="modal__footer">
              <p class="footer__text1"> {{ $t('chargepointPairing.ending1') }} </p>
              <div class="footer__divider"></div>
              <div class="footer__text2__container">
                <span class="footer__text2"> {{ $t('chargepointPairing.ending2') }}&nbsp;</span>
                <a :href="connectionLink" target="_blank" class="footer__text2">{{ $t('chargepointPairing.supportArticleLink') }}&nbsp;</a>
                <span class="footer__text2"> {{ $t('chargepointPairing.ending3') }}&nbsp;</span>
                <a
                  class="footer__text2"
                  v-bind:href="'mailto:' + supportEmail"
                  >{{ supportEmail }}</a
                >
                <span class="footer__text2">.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'ChargePointSupportModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: Object,
      default: () => defaultTheme,
    },
    supportEmail: {
      type: String,
      required: true,
    },
    connectionLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    if (this.visible) {
      document.body.style.overflow = 'hidden';
    }
  },
  watch: {
    visible(val) {
      document.body.style.overflow = val ? 'hidden' : '';
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 576;
    },
  },
  computed: {
    supportStepIconSvg() {
      return `
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
          <circle cx="10" cy="10" r="10" fill="#F7A529" />
          <line x1="5" y1="10" x2="15" y2="10" stroke="black" stroke-width="2"/>
          <line x1="10" y1="5" x2="10" y2="15" stroke="black" stroke-width="2"/>
        </svg>
      `;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins.scss';
.modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;

  .modal__wrapper {
    background: #fff;
    border-radius: 8px;
    margin: auto;
    position: relative;
    width: 681px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .modal__header {
      display: flex;
      height: 80px;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 0 40px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);

      .modal__header__title {
        margin: 0;
        font-size: 24px;
        align-self: center;
      }

      .modal__close {
        background: transparent;
        padding: 0;
        display: flex;
        align-items: flex-start;
        max-width: 18px;
        max-height: 18px;

        img {
          align-self: flex-start;
        }
      }
    }

    .modal__content {
      width: 100%;
      height: auto;

      .steps__container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        width: 100%;
        height: 100%;
        margin-top: 40px;
        padding-left: 40px;
        padding-right: 40px;
        box-sizing: border-box;

        .step {
          max-width: 175px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0;
          margin-right: 0px;

          .step__box {
            border: 1px solid #BDBDBD;
            border-radius: 8px;
            margin-bottom: 16px;
            width: 130px;
            height: 130px;
            display: flex;
            flex-direction: column;

            .step__icon {
              width: 20px;
              height: 20px;
              margin: 15px 0 13px 14px;
            }
            .step__label {
              font-size: 10px;
              font-weight: bold;
              align-self: center;
            }
          }

          .step__number {
            width: 30px;
            height: 30px;
            color: white;
            border-radius: 9999px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: bold;
            margin-top: 5px;
            margin-bottom: 10px;
          }

          .step__title {
            font-size: 12px;
            font-weight: bold;
            margin: 6px 0 0 0;
          }
          .step__description {
            font-size: 12px;
            color: #4F4F4F;
            text-align: center;
            margin-top: 16px;
          }
        }

        [class^='step__line'] {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
        }
        .step__line__step-one {
          margin-left: 100px;
        }
        .step__line__step-three {
          margin-right: 100px;
        }
        .step__divider {
          width: 75px;
          border-top: 1px dashed #A6B1C3;
        }
        .step__divider-left {
          margin-right: 12px;
        }
        .step__divider-right {
          margin-left: 12px;
        }
      }
    }

    .modal__footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 0 auto;

      .footer__text1 {
        font-size: 12px;
        text-align: center;
        margin: 10px 0 0 0;
        padding: 0 16px;
      }
      .footer__divider {
        width: 88%;
        border-bottom: 1px solid #AFAFAF;
        margin: 22px 0 20px 0;
      }
      .footer__text2__container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        width: 100%;
        text-align: center;
        margin-bottom: 30px;

        .footer__text2 {
          font-size: 12px;
          color: #AFAFAF;
          text-align: center;
        }
      }
    }
  }
}

.lookup-step-box__container,
.pairing-step-box_container {
  background-color: #BDBDBD;
}
.lookup-step-box {
  width: 105px;
  height: 130px;
  background-color: white;
  border-radius: 7.5px 0 0 7.5px;

  .lookup-step-box__label {
    font-size: 8px;
    font-weight: bold;
    color: #6b7280;
    margin: 15px 0 4px 15px;
  }
  .lookup-step-box__input-placeholder {
    width: 66px;
    height: 15px;
    background-color: #ECECEC;
    margin-left: 15px;
  }
}
.pairing-step-box {
  width: 105px;
  height: 130px;
  background-color: white;
  border-radius: 7.5px 0 0 7.5px;

  .pairing-step-box__dot {
    width: 20px;
    height: 20px;
    background-color: #10b981;
    border-radius: 9999px;
    margin: 6px 0 0 15px;
  }
  .pairing-step-box__label {
    font-size: 8px;
    font-weight: bold;
    color: #4F4F4F;
    &.pairing-step-box__label1 {
      margin: 15px 0 8px 15px;
    }
    &.pairing-step-box__label2 {
      margin: 5px 0 0 15px;
    }
    &.pairing-step-box__label3 {
      font-size: 6px;
      font-weight: 600;
      margin: 20px 0 0 15px;
    }
  }
  .pairing-step-box__line {
    width: 58px;
    border-bottom: 1px solid #BDBDBD;
    margin: 14px 0 0 17px;
  }
}

/* Transitions */
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
}

/* Mobile Styles */
@media (max-width: 576px) {
  .modal__overlay {
    padding: 39px 0 29px 0;

    .modal__wrapper {
      width: 100%;
      max-width: 351px;
      height: 100%;
      overflow: hidden;

      .modal__header {
        position: sticky;
        top: 0;
        z-index: 2;
        min-height: 80px;
        padding: 0 25px 0 20px;
        flex-shrink: 0;

        .modal__header__title {
          font-size: 20px;
        }
      }

      .modal__content {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        overflow: hidden;

        .mobile-steps__wrapper {
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .steps__container {
          flex-direction: column;
          margin: 30px 0 0 0;
          padding: 0;

          .step {
            flex-direction: row;
            width: 100%;
            align-items: unset;

            .step__indicator-container {
              width: 40px;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-right: 19px;
              margin-left: 39px;

              &.step__indicator-container-one {
                margin-top: 51px;
              }
              .step__number {
                margin: 0;
              }
            }
            .step__content {
              display: flex;
              flex-direction: column;
              align-items: center;
              min-width: 175px;
            }
          }
        }
      }
      .modal__footer {
        .footer__divider {
          margin: 14px 0 16px 0;
          padding: 0 30px;
          width: 291px;
        }
        .footer__text1 {
          padding: 0;
          margin: 0 30px;
        }
        .footer__text2__container {
          margin: 0 30px 10px 30px;
        }
      }
    }
  }
  [class^='mobile-step__line'] {
    height: 100px;
    width: 1px;
    flex-grow: 1;
    background-image: repeating-linear-gradient(
      to bottom,
      #A6B1C3,
      #A6B1C3 4px,
      transparent 4px,
      transparent 8px
    );
  }
  .mobile-step__line-top {
    height: 37px;
    margin-bottom: 14px;
    flex-grow: unset;
  }
  .mobile-step__line-bottom {
    margin-top: 14px;
  }
  .step__title {
    text-align: center;
  }
  .step__description {
    margin: 16px 0 30px 0;
  }
}
</style>
